import { useEffect, useState } from "react"
import { getHeaderList } from "../../services/header/header.service";
import { Link } from 'react-router-dom';
import Heading from "../../components/heading/heading";
import Title from '../../components/title';
import styles from './Sitemap.module.css';

const Sitemap = () => {
    let [header, setHeader] = useState([]);
    useEffect(() => {
        getHeaderList().then(
            ({ data }) => {
                setHeader(data.data)
            }
        )
    }, []);

    return (<>
        <Title title={'نقشه سایت'} />
        <div className={'container'}>
            <div className={styles.sitemapWrapper}>
                <ul className={styles.sitemapList}>
                    {header.map((item, key) => (<li key={key + 'header-menu'} className={styles.listItem}>
                        <Link className={item.destination_url ?
                            null :
                            'no-cursor'} to={item.destination_url ? item.destination_url : null}>
                            {item.title}
                        </Link>
                        {item.children ?
                            <ul>
                                {item.children.map((sub) => (<li>
                                    <Link className={sub.destination_url ?
                                        null :
                                        styles.noCursor} to={sub.destination_url ?
                                            sub.destination_url : null}>
                                        {sub.title}
                                    </Link>
                                    <ul>
                                        {sub.children.map((child) => (<li>
                                            <Link className={child.destination_url ?
                                                null :
                                                styles.noCursor} to={child.destination_url ? child.destination_url : null}>
                                                {child.title}
                                            </Link>
                                        </li>))}
                                    </ul>
                                </li>))}
                            </ul>
                            : null}
                    </li>))}
                </ul>
            </div>
        </div>
    </>);
}

export default Sitemap;